import { render, staticRenderFns } from "./GalleryMediaItem.vue?vue&type=template&id=2d1a4148&scoped=true&"
import script from "./GalleryMediaItem.vue?vue&type=script&lang=js&"
export * from "./GalleryMediaItem.vue?vue&type=script&lang=js&"
import style0 from "./GalleryMediaItem.vue?vue&type=style&index=0&id=2d1a4148&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d1a4148",
  null
  
)

export default component.exports